/* Stampify theme.js */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    const value = (cents / 100);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const m = format.match(placeholder);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toLocaleString('de-DE'); break;
      case 'amount_with_apostrophe_separator': out = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"); break;
      default: out = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return format.replace(placeholder, out);
  }

  function toast(msg, link, linkText) {
    let el = qs('.toast');
    if (!el) { el = document.createElement('div'); el.className = 'toast'; document.body.appendChild(el); }
    el.innerHTML = '<span></span>' + (link ? '<a href="' + link + '">' + linkText + '</a>' : '');
    el.firstChild.textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 3500);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(el => { el.textContent = count; el.dataset.count = count; });
  }

  /* ---------- reveal on scroll ---------- */
  const revealEls = qsa('[data-reveal]');
  function reveal() {
    const limit = window.innerHeight * 0.94;
    for (let i = revealEls.length - 1; i >= 0; i--) {
      const el = revealEls[i];
      if (el.getBoundingClientRect().top < limit) { el.classList.add('is-in'); revealEls.splice(i, 1); }
    }
    if (!revealEls.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
  }
  let ticking = false;
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(() => { reveal(); ticking = false; }); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', reveal);
  reveal();

  /* ---------- header: ombra allo scroll ---------- */
  const hdrEl = qs('[data-header]');
  if (hdrEl) {
    const onScrollHeader = () => hdrEl.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ---------- fascia: parallasse leggera ---------- */
  const bands = qsa('.band');
  if (bands.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let queued = false;
    const moveBands = () => {
      bands.forEach(band => {
        const media = qs('.band__media', band);
        if (!media) return;
        const r = band.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        const p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        media.style.transform = 'translate3d(0,' + (p * -46).toFixed(1) + 'px,0) scale(1.14)';
      });
      queued = false;
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(moveBands); } }, { passive: true });
    window.addEventListener('resize', moveBands);
    moveBands();
    if ('IntersectionObserver' in window) {
      const bio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); bio.unobserve(e.target); } }), { threshold: 0.25 });
      bands.forEach(b => bio.observe(b));
    } else { bands.forEach(b => b.classList.add('is-in')); }
  } else { bands.forEach(b => b.classList.add('is-in')); }

  /* ---------- drawer menu ---------- */
  const drawer = qs('[data-drawer]');
  if (drawer) {
    qsa('[data-drawer-open]').forEach(b => b.addEventListener('click', () => { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }));
    qsa('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', () => { drawer.removeAttribute('open'); document.body.style.overflow = ''; }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.hasAttribute('open')) { drawer.removeAttribute('open'); document.body.style.overflow = ''; } });
  }

  /* ---------- hero video: sound toggle ---------- */
  qsa('[data-sound-toggle]').forEach(btn => {
    const video = qs('video', btn.closest('[data-hero-media]'));
    const label = qs('[data-sound-label]', btn);
    if (!video) return;
    btn.addEventListener('click', () => {
      const turnOn = video.muted;
      video.muted = !turnOn;
      if (turnOn) { video.currentTime = 0; }
      video.play().catch(() => {});
      btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
      if (label) label.textContent = turnOn ? label.dataset.off : label.dataset.on;
    });
    // when it scrolls out of view with sound on, mute again so it doesn't talk over the page
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting && !video.muted) { video.muted = true; btn.setAttribute('aria-pressed', 'false'); if (label) label.textContent = label.dataset.on; }
      }, { threshold: 0.25 }).observe(video);
    }
  });

  /* ---------- hero video modal + sticky home CTA ---------- */
  const vmodal = qs('[data-video-modal]');
  if (vmodal) {
    const mv = qs('video', vmodal);
    const heroVideo = qs('[data-hero-media] video');
    const open = () => {
      if (typeof vmodal.showModal === 'function') vmodal.showModal(); else vmodal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      if (heroVideo) heroVideo.pause();
      if (mv) { mv.muted = false; mv.currentTime = 0; mv.play().catch(() => {}); }
    };
    const close = () => {
      if (mv) mv.pause();
      if (vmodal.open) vmodal.close(); else vmodal.removeAttribute('open');
      document.body.style.overflow = '';
      if (heroVideo) heroVideo.play().catch(() => {});
    };
    qsa('[data-video-open]').forEach(b => b.addEventListener('click', open));
    qsa('[data-video-close]', vmodal).forEach(b => b.addEventListener('click', close));
    vmodal.addEventListener('click', e => { if (e.target === vmodal) close(); });
    vmodal.addEventListener('close', () => { if (mv) mv.pause(); document.body.style.overflow = ''; });
  }
  const stickyHome = qs('[data-sticky-home]');
  const hero = qs('[data-hero]');
  if (stickyHome && hero && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-home');
    const sizes = qs('#taglie');
    let heroOut = false, sizesIn = false;
    const update = () => stickyHome.classList.toggle('is-visible', heroOut && !sizesIn);
    new IntersectionObserver(en => { heroOut = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }, { threshold: 0.05 }).observe(hero);
    if (sizes) new IntersectionObserver(en => { sizesIn = en[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(sizes);
  }

  /* ---------- UGC videos: play on click ---------- */
  qsa('[data-ugc]').forEach(item => {
    const video = qs('video', item);
    if (!video) return;
    item.addEventListener('click', () => {
      if (video.paused) { qsa('[data-ugc] video').forEach(v => { if (v !== video) { v.pause(); v.closest('[data-ugc]').classList.remove('is-playing'); } }); video.muted = false; video.play(); item.classList.add('is-playing'); }
      else { video.pause(); item.classList.remove('is-playing'); }
    });
  });

  /* ---------- lazy video autoplay when visible ---------- */
  if ('IntersectionObserver' in window) {
    const vio = new IntersectionObserver(entries => {
      entries.forEach(e => {
        const v = e.target;
        if (e.isIntersecting) { v.play().catch(() => {}); } else if (v.hasAttribute('data-autoplay')) { v.pause(); }
      });
    }, { threshold: 0.2 });
    qsa('video[data-autoplay]').forEach(v => vio.observe(v));
  }

  /* ---------- product form ---------- */
  qsa('[data-product-form]').forEach(section => {
    const form = qs('form[data-product-form-el]', section);
    if (!form) return;
    const productJson = qs('[data-product-json]', section);
    if (!productJson) return;
    const product = JSON.parse(productJson.textContent);
    const idInput = qs('input[name="id"]', form);
    const priceEl = qs('[data-price]', section);
    const compareEl = qs('[data-compare-price]', section);
    const saveEl = qs('[data-save]', section);
    const addBtn = qs('[data-add-to-cart]', form);
    const addBtnText = qs('[data-add-to-cart-text]', form);
    const stockEl = qs('[data-stock]', section);
    const stickyPrice = qs('[data-sticky-price]', section);
    const stickyVariant = qs('[data-sticky-variant]', section);
    const optionInputs = qsa('.variant-option input', section);
    const gallery = qs('[data-gallery]', section);

    function currentVariant() {
      const selected = optionInputs.filter(i => i.checked).map(i => i.value);
      if (!selected.length) return product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];
      return product.variants.find(v => v.options.every((o, i) => o === selected[i])) || null;
    }

    function render(variant) {
      const strings = window.theme.strings;
      if (!variant) {
        addBtn.disabled = true; addBtnText.textContent = strings.unavailable; return;
      }
      idInput.value = variant.id;
      const url = new URL(window.location); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = saveEl.dataset.template.replace('[amount]', formatMoney(variant.compare_at_price - variant.price)); }
      priceEl && priceEl.closest('.price').classList.toggle('price--sale', !!onSale);
      if (variant.available) { addBtn.disabled = false; addBtnText.textContent = strings.addToCart; }
      else { addBtn.disabled = true; addBtnText.textContent = strings.soldOut; }
      if (stockEl) stockEl.hidden = !variant.available;
      // variant image
      if (gallery) {
        const vt = qs('.gallery__thumb[data-variant-id="' + variant.id + '"]', gallery);
        if (vt) vt.click();
        else if (variant.featured_media) { const thumb = qs('.gallery__thumb[data-media-id="' + variant.featured_media.id + '"]', gallery); if (thumb) thumb.click(); }
      }
      // mark unavailable options (single-option products)
      if (product.options.length === 1) {
        optionInputs.forEach(inp => {
          const v = product.variants.find(vv => vv.option1 === inp.value);
          inp.closest('.variant-option').classList.toggle('is-unavailable', !(v && v.available));
        });
      }
    }

    optionInputs.forEach(i => i.addEventListener('change', () => render(currentVariant())));
    render(currentVariant());

    // quantity
    qsa('.qty', section).forEach(q => {
      const input = qs('input', q);
      qs('[data-qty-minus]', q).addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1) - 1); });
      qs('[data-qty-plus]', q).addEventListener('click', () => { input.value = parseInt(input.value || 1) + 1; });
    });

    // ajax add
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      const original = addBtnText.textContent;
      addBtn.disabled = true; addBtnText.textContent = '…';
      try {
        const fd = new FormData(form);
        const res = await fetch(window.theme.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) { const err = await res.json(); throw new Error(err.description || err.message); }
        const cart = await fetch(window.theme.routes.cart + '.js').then(r => r.json());
        updateCartCount(cart.item_count);
        toast(window.theme.strings.added, window.theme.routes.cart, window.theme.strings.viewCart);
      } catch (err) {
        toast(err.message || 'Errore');
      } finally {
        addBtn.disabled = false; addBtnText.textContent = original;
      }
    });

    // sticky buy bar
    const sticky = qs('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      const sio = new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      });
      sio.observe(form);
      qs('button', sticky).addEventListener('click', () => form.requestSubmit());
    }

    // gallery
    if (gallery) {
      const slides = qsa('.gallery__slide', gallery);
      const thumbs = qsa('.gallery__thumb', gallery);
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        thumbs.forEach(x => x.classList.remove('is-active'));
        slides.forEach(x => { x.classList.remove('is-active'); const v = qs('video', x); if (v) v.pause(); });
        t.classList.add('is-active'); slides[i].classList.add('is-active');
        const v = qs('video', slides[i]); if (v) v.play().catch(() => {});
        t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }));
      // swipe
      let x0 = null;
      gallery.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        const cur = thumbs.findIndex(t => t.classList.contains('is-active'));
        const next = dx < 0 ? Math.min(cur + 1, thumbs.length - 1) : Math.max(cur - 1, 0);
        thumbs[next] && thumbs[next].click();
      });
    }
  });

  /* ---------- cart page ---------- */
  const cartPage = qs('[data-cart-page]');
  if (cartPage) {
    async function change(line, quantity) {
      cartPage.style.opacity = '.6';
      const res = await fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const cart = await res.json();
      updateCartCount(cart.item_count);
      // simplest robust approach: reload section markup
      const html = await fetch(window.location.pathname + '?section_id=' + cartPage.dataset.sectionId).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = qs('[data-cart-page]', doc);
      cartPage.replaceWith(fresh);
      bindCart(fresh);
    }
    function bindCart(root) {
      qsa('[data-line-minus]', root).forEach(b => b.addEventListener('click', () => change(+b.dataset.line, Math.max(0, +b.dataset.qty - 1))));
      qsa('[data-line-plus]', root).forEach(b => b.addEventListener('click', () => change(+b.dataset.line, +b.dataset.qty + 1)));
      qsa('[data-line-remove]', root).forEach(b => b.addEventListener('click', e => { e.preventDefault(); change(+b.dataset.line, 0); }));
      qsa('[data-line-qty]', root).forEach(i => i.addEventListener('change', () => change(+i.dataset.line, Math.max(0, parseInt(i.value || 0)))));
    }
    bindCart(cartPage);
  }

  /* ---------- localization form auto-submit ---------- */
  qsa('[data-localization-form] select').forEach(sel => sel.addEventListener('change', () => sel.form.submit()));

  /* ---------- address forms (customers/addresses) ---------- */
  qsa('[data-address-toggle]').forEach(b => b.addEventListener('click', () => {
    const t = qs(b.dataset.addressToggle); if (t) t.hidden = !t.hidden;
  }));
  qsa('[data-address-delete]').forEach(b => b.addEventListener('click', () => {
    if (!confirm(b.dataset.confirm)) return;
    const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.target;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  }));
  // country/province selectors
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    qsa('[data-address-form]').forEach(f => {
      const id = f.dataset.addressForm;
      new Shopify.CountryProvinceSelector('AddressCountry_' + id, 'AddressProvince_' + id, { hideElement: 'AddressProvinceContainer_' + id });
    });
  }
})();

(function(){var h=document.querySelector('.header');if(!h)return;var set=function(){document.documentElement.style.setProperty('--header-h',h.offsetHeight+'px')};set();window.addEventListener('resize',set);window.addEventListener('load',set)})();

/* ---------- racconto a scorrimento (i tre gesti) ---------- */
(function(){
  var story=document.querySelector('[data-story]'); if(!story) return;
  var steps=[].slice.call(story.querySelectorAll('[data-story-step]'));
  var imgs=[].slice.call(story.querySelectorAll('[data-story-img]'));
  var fill=story.querySelector('[data-story-fill]');
  var counter=story.querySelector('[data-story-counter]');
  var rail=story.querySelector('.story__rail');
  var current=-1, ticking=false;
  function pad(n){return (n<9?'0':'')+(n+1)}
  function update(){
    ticking=false;
    var vh=window.innerHeight, focus=vh*0.5, best=0, bestD=Infinity;
    steps.forEach(function(s,i){
      var r=s.getBoundingClientRect(); var c=r.top+r.height/2; var d=Math.abs(c-focus);
      if(d<bestD){bestD=d;best=i}
    });
    if(best!==current){
      current=best;
      steps.forEach(function(s,i){s.classList.toggle('is-active',i===best)});
      imgs.forEach(function(m,i){m.classList.toggle('is-active',i===best)});
      [].slice.call(story.querySelectorAll('[data-story-dot]')).forEach(function(d,i){d.classList.toggle('is-active',i<=best)});
      if(counter) counter.textContent=pad(best);
    }
    if(fill&&rail){
      var rr=rail.getBoundingClientRect();
      var p=(focus-rr.top)/rr.height; p=Math.max(0,Math.min(1,p));
      fill.style.transform='scaleY('+p+')';
    }
  }
  function onScroll(){ if(!ticking){ticking=true;requestAnimationFrame(update)} }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
  update();
})();
